import { config } from '../config';
import { headers, APIResponse, fetchAPI, SpanTag, stleaf } from '../helpers';

export interface CheckSSOResult {
  sso: boolean;
  authorizationUrl?: string;
}

export const checkSSO = (
  st: SpanTag,
  email: string,
): Promise<APIResponse<CheckSSOResult>> => {
  const params = new URLSearchParams({ email });
  const url = `${config.API_URL}/v2/auth/sso/check?${params}`;
  return fetchAPI<CheckSSOResult>(stleaf(st, 'sso_check'), url, {
    method: 'GET',
    headers,
    credentials: 'include',
  });
};
